import {Component, OnInit} from '@angular/core';
import {Carteira} from "../../../carteira/carteira.model";
import {MaskUtil} from "../../util/mask-util";

@Component({
  selector: 'app-modal-carteira',
  templateUrl: './modal-carteira.component.html',
  styleUrls: ['./modal-carteira.component.scss']
})
export class ModalCarteiraComponent implements OnInit {

  data: Carteira;

  constructor() { }

  ngOnInit(): void {
  }


    formatCnpj(cnpj: string) {
        return MaskUtil.formatCnpj(cnpj);
    }
}
